import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { Spinner } from "baseui/spinner";
import publicIp from 'public-ip';
import PropTypes from 'prop-types'
import jwt from 'jsonwebtoken';
import JobLandingPage from '../../components/JobLandingPage/JobLandingPage';
import { ApiConstant, PageConstant } from '../../constants';
import { checkProfileStatus } from '../../legacy_components/services/commonAPI';
import { checkAndSaveExternalSourcing } from '../../services/ExternalSourcing';
import { getUserObject } from '../../legacy_components/util/getUserFullName';
import { pushLog2DV2LogServer } from '../../services/logging';


const JobLandingPageContainer = ({ location, history }) => {
    const [jobData, setJobData] = useState({});
    const [loading, setLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [user_email, setUserEmail] = useState(null);
    const [devSource, setDevSource] = useState('');

    const params = new URLSearchParams(location.search);

    const logUserVisitData = async (email=null, name=null) => {
      let ip = "";
      const { uid } = getUserObject() || {};
      const jobToken = params.get('jobToken');
      const source = jobToken ? 'External Sourcing' : 'Direct Apply'
      try {
        ip = await publicIp.v4();
      } catch(e) {
        return pushLog2DV2LogServer.error(
          "JOB_FROM_WEBSITE_TO_DEV_PORTAL_LOGGING",
          name ? name : email ? "JOB_FROM_WEBSITE_TO_DEV_PORTAL_ALREADY_SIGNIN" : "JOB_FROM_WEBSITE_TO_DEV_PORTAL_NOT_SIGNIN",
          { user_ip: ip, email: email || '' },
          {  page: "NEW_JOB_FROM_WEBSITE_TO_DEV_PORTAL", source, user_id: uid || ''  },
          { error_message: e.message }
        )
      }
      return pushLog2DV2LogServer.info(
        "JOB_FROM_WEBSITE_TO_DEV_PORTAL_LOGGING",
        name ? name : email ? "JOB_FROM_WEBSITE_TO_DEV_PORTAL_ALREADY_SIGNIN" : "JOB_FROM_WEBSITE_TO_DEV_PORTAL_NOT_SIGNIN",
        { user_ip: ip, email: email || '' },
        {  page: "NEW_JOB_FROM_WEBSITE_TO_DEV_PORTAL", source, user_id: uid || ''  },
        null
      )
    }
    useEffect(() => {
      const { email } = getUserObject() || {};
      if (email && !user_email) setUserEmail(email);
      logUserVisitData(user_email || email)
    }, [])

    useEffect(() => {
        const fetchJobData = async () => {
          setLoading(true);
          // Parse the query parameters from the URL
          const jobId = params.get('jobId');
          const jobCode = params.get('jobCode');
          const jobToken = params.get('jobToken');
          if (jobToken) {
            const tokenData = jwt.decode(jobToken);
            if (tokenData?.userRole) {
              setDevSource(tokenData.userRole)
            }
          }
          // Redirect if neither jobId nor jobCode is present
          if (!jobId && !jobCode) {
            history.push(PageConstant.JOB_PAGE);
            return;
          }
          // Determine which parameter to send
          const queryParam = jobId ? { jobId } : { jobCode };
    
          try {
            // Make the API call with either jobId or jobCode
            const response = await axios.get(`${ApiConstant.BASE_URL}job/public`, {
              params: queryParam,
            });
    
            // Redirect if job_title is not present in the response
            if (!response.data?.success || !response.data?.result?.public_code) {
                console.warn('Couldn\'t fetch job code');
                history.push(PageConstant.JOB_PAGE);
                return;
            }
            setJobData(response.data?.result || {})

          } catch (error) {
            console.error('Error fetching job data:', error);
            history.push(PageConstant.JOB_PAGE);
          } finally {
            setLoading(false)
          }
        };
    
        fetchJobData();
    }, [location.search, history]);

    const saveExternalSourcingData = async () => {
      try {
        const jobToken = params.get('jobToken');
        if (!jobToken) return;
        const { email } = getUserObject() || {};
        const formData = {
          email: user_email || email,
          token: jobToken
        }
        const response = await checkAndSaveExternalSourcing(formData);
        const { data } = response;
        const { message, developerSource, success, jobCode } = data;
        if (success && developerSource && jobCode) {
          setDevSource(developerSource)
        } else {
          console.log("Job landing page container : ", message);
        }
      } catch(e) {
        console.error(e.message)
      }
      return true;
    }

    const checkAccountExistsStatus = async ({ accountExists, email }) => {
      setUserEmail(email);
      if (!accountExists) {
        await logUserVisitData(email, 'JOB_FROM_WEBSITE_TO_DEV_PORTAL_USER_SIGNUP');
      } else {
        await logUserVisitData(email, 'JOB_FROM_WEBSITE_TO_DEV_PORTAL_USER_SIGNIN');
      }
      await checkProgressStatus(null, true);
    }
    // Add first parameter a, because this is also called from continue button and will always have first parameter
    // as instance of a button class
    const checkProgressStatus = async (a, from_auth=false) => {
      try {
        setBtnLoading(true);
        await saveExternalSourcingData();
        const jobCode = jobData.public_code;

        if (!from_auth) {
          await logUserVisitData(user_email, 'JOB_FROM_WEBSITE_TO_DEV_PORTAL_USER_CLICKED_CONTINUE');
        }
        let notificationChannel = '';
        const url = new URL(window.location.href);
        if (url && url.search) {
          const searchParams = url.search.split('notificationChannel=');
          if (searchParams.length > 1) {
            notificationChannel = searchParams[1];
          }
        }
  
        const profileCompletedData = await checkProfileStatus();
        const {
          data: {
            result: [
              {
                result: onboardingCompleted = false
              } = {}
            ] = []
          } = {}
        } = profileCompletedData || {};
    
        let hasApplied = false;
        let vetsmithFlowLink = null;
        let vetsmithFlowCompleted = false;
        
        try {
          const response = await axios.post(`${ApiConstant.BASE_URL}job/interest-form`, {
            jobCode,
            primarySource: devSource ? devSource : 'RECOMMENDED_JOB',
            subSource: devSource === 'RECOMMENDED_JOB' ? document.referrer : '',
            notificationChannel: notificationChannel,
          });
    
          const {
            data: {
              result: {
                hasApplied: applied = false,
                vetsmithFlowLink: link = null,
                vetsmithFlowCompleted: completed = false
              } = {}
            } = {}
          } = response || {};
    
          hasApplied = applied;
          vetsmithFlowLink = link;
          vetsmithFlowCompleted = completed;
        } catch (error) {
          console.error("Error job/interest-form:", error);
        }
        if (!onboardingCompleted) {
          window.location.href = `${PageConstant.PROFILE_ONBOARDING}?jobCode=${jobCode}`;
          return
        }
    
        if (hasApplied && vetsmithFlowLink && !vetsmithFlowCompleted && jobData.job_id) {
          window.location.href = `${PageConstant.JOB_PAGE}/${jobData.job_id}/specialized-vetting?source=icf`;
          return;
        }
        window.location.href = `${PageConstant.JOB_PAGE}?jobCode=${jobCode}`;
      } catch (error) {
        console.error("Error in checkProgressStatus:", error);
        setBtnLoading(false);
      }
    };
    

    if (loading) {
      return <Spinner />;
    }
    const loc_param = params.get("country") || params.get("city");
    return (
        <>
            <span class="job-page-card__location">{loc_param}</span>
            <JobLandingPage btnLoading={btnLoading} onContinue={checkProgressStatus} job={jobData} checkAccountExistsStatus={checkAccountExistsStatus} />
        </>
    )
}

JobLandingPageContainer.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
}

export default withRouter(JobLandingPageContainer);